<ngx-loading-bar [color]="'#902b3d'" [includeSpinner]="false" [height]="'4px'"></ngx-loading-bar>
<app-loader></app-loader>
<router-outlet></router-outlet>